import {XHTTP} from '@/shared/xhttp';
import {VenteService} from "@/xhttp/VenteService";
import {Client} from "@/models/Client";
import {DateHelper} from "@/shared/utils";
import {BoisType} from "@/models/BoisType";
import {LongueursVente} from "@/models/LongueursVente";
import {Transporteur} from "@/models/Transporteur";
import {Commande} from "@/models/Commande";

@XHTTP(VenteService, '/ventes')
export class Vente {

	private _id: number;
	private _date: string = (new Date()).toISOString().split('T')[0]
	private _hours: string = '08:00';
	private _client: Client;
	private _boisType: BoisType;
	private _longueursVente: LongueursVente;
	private _volume: number;
	private _prixStere: number;
	private _transporteur: Transporteur;
	private _chauffeur: string;
	private _facture: boolean;
	private _commande: Commande;
	private _dateDelivery: Date;
	private _delivered: boolean;
	private _venduNonLivre: boolean;
	private _createdAt: Date;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get date(): string {
		return this._date;
	}

	public get hours(): string {
		return this._hours;
	}

	public get client(): Client {
		return this._client;
	}

	public get boisType(): BoisType {
		return this._boisType;
	}

	public get longueursVente(): LongueursVente {
		return this._longueursVente;
	}

	public get volume(): number {
		return this._volume;
	}

	public get prixStere(): number {
		return this._prixStere;
	}

	public get transporteur(): Transporteur {
		return this._transporteur;
	}

	public get chauffeur(): string {
		return this._chauffeur;
	}

	public get facture(): boolean {
		return this._facture;
	}

	public get commande(): Commande {
		return this._commande;
	}

	public get dateDelivery(): Date {
		return this._dateDelivery;
	}

	public get delivered(): boolean {
		return this._delivered;
	}

	public get venduNonLivre(): boolean {
		return this._venduNonLivre;
	}

	public get createdAt(): Date {
		return this._createdAt;
	}

	/////////////
	// Setters //
	/////////////

	public set date(value: string) {
		this._date = value;
	}

	public set hours(value: string) {
		this._hours = value;
	}

	public set client(value: Client) {
		this._client = value;
	}

	public set boisType(value: BoisType) {
		this._boisType = value;
	}

	public set longueursVente(value: LongueursVente) {
		this._longueursVente = value;
	}

	public set volume(value: number) {
		this._volume = value;
	}

	public set prixStere(value: number) {
		this._prixStere = value;
	}

	public set transporteur(value: Transporteur) {
		this._transporteur = value;
	}

	public set chauffeur(value: string) {
		this._chauffeur = value;
	}

	public set facture(value: boolean) {
		this._facture = value;
	}

	public set commande(value: Commande) {
		this._commande = value;
	}

	public set dateDelivery(value: Date) {
		this._dateDelivery = value;
	}

	public set delivered(value: boolean) {
		this._delivered = value;
	}

	public set venduNonLivre(value: boolean) {
		this._venduNonLivre = value;
	}

	///////////////
	// Serialize //
	///////////////+

	public toJSON(): any {
		return {
			id       : this._id,
			date    : this._date + 'T' + this._hours + ':00',
			client  : this._client ? this._client.id : null,
			boisType : this._boisType,
			longueursVente : this._longueursVente,
			volume : this._volume,
			prixStere : this._prixStere,
			transporteur  : this._transporteur,
			chauffeur: this._chauffeur,
			facture   : this._facture,
			commande  : this._commande,
			dateDelivery    : this._dateDelivery ? DateHelper.toLocalizedString(this._dateDelivery) : null,
			delivered   : this._delivered,
			venduNonLivre   : this._venduNonLivre,
		};
	}

	public fromJSON(data: any): this {
		this._id        = data.id;
		this._date         = data.date ? data.date.substr(0,10) : null;
		this._hours         = data.date ? data.date.substr(11,5) : null;
		this._client   = data.client ? (new Client()).fromJSON(data.client) : null;
		this._boisType   = data.boisType ? (new BoisType()).fromJSON(data.boisType) : null;
		this._longueursVente   = data.longueursVente ? (new LongueursVente()).fromJSON(data.longueursVente) : null;
		this._volume  = data.volume;
		this._prixStere  = data.prixStere;
		this._transporteur   = data.transporteur ? (new Transporteur()).fromJSON(data.transporteur) : null;
		this._chauffeur = data.chauffeur;
		this._facture    = data.facture;
		this._commande   = data.commande ? (new Commande()).fromJSON(data.commande) : null;
		this._dateDelivery         = data.dateDelivery ? DateHelper.fromLocalizedString(data.dateDelivery) : null;
		this._delivered    = data.delivered;
		this._venduNonLivre    = data.venduNonLivre;
		this._createdAt                  = data.createdAt ? new Date(data.createdAt) : null;
		return this;
	}
}
